<div class="pfspo-availability">
  <ngx-line-item-pfspo-selector
    [disabled]="disabled"
    [dialog]="false"
  >
  </ngx-line-item-pfspo-selector>
</div>
